export const MODULE_NAME = 'PAYMENTS_MODULE';
